import { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { firebaseApp } from '../FirebaseConfig';
import { ISuspiciousUsersIndicator } from 'src/api/suspicious-users/data/interfaces/suspicious-user-indicator.interface';
import { firebaseAuth } from 'src/constants';

export const useSuspiciousUsersIndicator = () => {
  const [newAlertsTimestamp, setNewAlertsTimestamp] = useState<{
    latest: number;
    latestSeen: number;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const db = getDatabase(firebaseApp);
    const suspiciousUsersRef = ref(db, 'panelData/suspiciousUsersIndicator');

    setLoading(true);
    setError(null);

    const unsubscribe = onValue(
      suspiciousUsersRef,
      (snapshot) => {
        try {
          const value = snapshot.val() as ISuspiciousUsersIndicator;
          const userId = firebaseAuth.currentUser?.uid;
          const lastSeenByAdmin = value.latestSeenByAdmin[userId] || 0;

          if (lastSeenByAdmin < value.latestAlert) {
            setNewAlertsTimestamp({
              latest: value.latestAlert,
              latestSeen: lastSeenByAdmin
            });
          } else {
            setNewAlertsTimestamp(null);
          }

          setLoading(false);
        } catch (err) {
          const error = err instanceof Error ? err : new Error('Unknown error');
          setError(error);
          setLoading(false);
        }
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return { data: newAlertsTimestamp, loading, error };
};
